import { render } from "./color.vue?vue&type=template&id=76de7d22"
import script from "./color.vue?vue&type=script&lang=js"
export * from "./color.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/horizontal/color.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76de7d22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76de7d22', __exports__)) {
    console.log('reload')
    api.reload('76de7d22', __exports__)
  }
  
  module.hot.accept("./color.vue?vue&type=template&id=76de7d22", () => {
    console.log('re-render')
    api.rerender('76de7d22', render)
  })

}


export default __exports__